import { Api } from '~/App/utils/api'
import { API_URL } from '~/constants/environment'

import type { AddCartItem } from '../@types'

const api = new Api(API_URL, 'customers/cart/items')

export const addCartItem = async (attributes: AddCartItem) => {
  return api.post<AddCartItem>({
    body: {
      data: {
        type: 'cart',
        attributes,
      },
    },
  })
}
